import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { ROLES, fetchMyPermissions } from '@/utils/permission'

Vue.use(VueRouter)

const routes = [
  // 管理端登录
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: () => import('@/views/admin/login/index.vue'),
    meta: { public: true }
  },
  {
        path: '/dashboard',
        name: 'AdminDashboard',
        component: () => import('@/views/admin/dashboard/index.vue'),
        meta: { title: '数据概览', icon: 'el-icon-s-data', roles: [ROLES.SUPER_ADMIN, ROLES.SUB_ADMIN] }
    },
  // 用户端布局
  {
    path: '/user',
    component: () => import('@/views/user/layout/index.vue'),
    redirect: '/user/home',
    children: [
      {
        path: 'home',
        name: 'UserHome',
        component: () => import('@/views/user/home/index.vue'),
        meta: { title: '首页' }
      },
      {
        path: 'profile',
        name: 'UserProfile',
        component: () => import('@/views/user/profile/index.vue'),
        meta: { title: '个人中心' }
      },
      {
        path: 'orders',
        name: 'UserOrders',
        component: () => import('@/views/user/orders/index.vue'),
        meta: { title: '我的订单' }
      },
      {
        path: 'team',
        name: 'UserTeam',
        component: () => import('@/views/user/team/index.vue'),
        meta: { title: '我的团队' }
      },
      {
        path: 'income',
        name: 'UserIncome',
        component: () => import('@/views/user/income/index.vue'),
        meta: { title: '我的收入' }
      },
      {
        path: 'mall',
        name: 'UserMall',
        component: () => import('@/views/user/mall/index.vue'),
        meta: { title: '商城' }
      },
      {
        path: 'news',
        name: 'UserNews',
        component: () => import('@/views/user/news/index.vue'),
        meta: { title: '新闻公告' }
      },
      {
        path: 'phone-plan',
        name: 'UserPhonePlan',
        component: () => import('@/views/user/phone-plan/index.vue'),
        meta: { title: '话费套餐' }
      },
      {
        path: 'staff-apply',
        name: 'UserStaffApply',
        component: () => import('@/views/user/staff-apply/index.vue'),
        meta: { title: '员工入驻' }
      }
    ]
  },
  // 管理端布局
  {
    path: '/admin',
    component: () => import('@/views/admin/layout/index.vue'),
    redirect: '/admin/dashboard',
    children: [
      {
        path: 'myTeam',
        name: 'AdminMyTeam',
        component: () => import('@/views/admin/myTeam/index.vue'),
        meta: { title: '我的团队', icon: 'el-icon-s-home', roles: [ROLES.CENTER, ROLES.LEADER] }
      },
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: () => import('@/views/admin/dashboard/index.vue'),
        meta: { title: '数据概览', icon: 'el-icon-s-data', roles: [ROLES.SUPER_ADMIN, ROLES.SUB_ADMIN] }
      },
      {
        path: 'profit',
        name: 'AdminProfit',
        component: () => import('@/views/admin/profit/index.vue'),
        meta: { title: '用户收益排行', icon: 'el-icon-s-finance', roles: [ROLES.SUPER_ADMIN, ROLES.SUB_ADMIN] }
      },
      {
        path: 'commission',
        name: 'AdminCommission',
        component: () => import('@/views/admin/commission/index.vue'),
        meta: { title: '分润明细对账', icon: 'el-icon-document', roles: [ROLES.SUPER_ADMIN, ROLES.SUB_ADMIN] }
      },
      {
        path: 'users',
        name: 'AdminUsers',
        component: () => import('@/views/admin/users/index.vue'),
        meta: { title: '用户管理', icon: 'el-icon-user-solid', roles: [ROLES.SUPER_ADMIN, ROLES.SUB_ADMIN, ROLES.SERVICE_CENTER] }
      },
      {
        path: 'orders',
        name: 'AdminOrders',
        component: () => import('@/views/admin/orders/index.vue'),
        meta: { title: '全部订单', icon: 'el-icon-s-order', roles: [ROLES.SUPER_ADMIN, ROLES.SUB_ADMIN, ROLES.SERVICE_CENTER] }
      },
      {
        path: 'orders/pending',
        name: 'PendingOrders',
        component: () => import('@/views/admin/orders/pending.vue'),
        meta: { title: '待审核订单', icon: 'el-icon-s-order', roles: [ROLES.SUPER_ADMIN, ROLES.SUB_ADMIN] }
      },
      {
        path: 'withdraw/index',
        name: 'AdminWithdraw',
        component: () => import('@/views/admin/withdraw/index.vue'),
        meta: { title: '全部提现', icon: 'el-icon-money', roles: [ROLES.SUPER_ADMIN, ROLES.SUB_ADMIN] }
      },
      {
        path: 'products',
        name: 'AdminProducts',
        component: () => import('@/views/admin/products/index.vue'),
        meta: { title: '商品管理', icon: 'el-icon-goods', roles: [ROLES.SUPER_ADMIN, ROLES.SUB_ADMIN] }
      },
      {
        path: 'product-types',
        name: 'ProductTypes',
        component: () => import('@/views/admin/products/types.vue'),
        meta: { title: '商品类型', icon: 'el-icon-collection', roles: [ROLES.SUPER_ADMIN, ROLES.SUB_ADMIN] }
      },
      {
        path: 'phone-plan',
        name: 'AdminPhonePlan',
        component: () => import('@/views/admin/phone-plan/index.vue'),
        meta: { title: '话费套餐', icon: 'el-icon-phone', roles: [ROLES.SUPER_ADMIN, ROLES.SUB_ADMIN] }
      },
      {
        path: 'staff-apply',
        name: 'StaffApply',
        component: () => import('@/views/admin/staff-apply/index.vue'),
        meta: { title: '员工入驻审核', icon: 'el-icon-s-custom', roles: [ROLES.SUPER_ADMIN, ROLES.SUB_ADMIN] }
      },
      {
        path: 'rosters',
        name: 'AdminRosters',
        component: () => import('@/views/admin/rosters/index.vue'),
        meta: { title: '个人信息管理', icon: 'el-icon-s-order', roles: [ROLES.SUPER_ADMIN, ROLES.SUB_ADMIN] }
      },
      {
        path: 'promotion',
        name: 'AdminPromotion',
        component: () => import('@/views/admin/promotion/index.vue'),
        meta: { title: '升级候选人', icon: 'el-icon-top', roles: [ROLES.SUPER_ADMIN, ROLES.SUB_ADMIN] }
      },
      {
        path: 'employee',
        name: 'AdminEmployee',
        component: () => import('@/views/admin/employee/index.vue'),
        meta: { title: '员工管理', icon: 'el-icon-s-custom', roles: [ROLES.SUPER_ADMIN, ROLES.SUB_ADMIN] }
      },
      {
        path: 'banners',
        name: 'AdminBanners',
        component: () => import('@/views/admin/banners/index.vue'),
        meta: { title: '轮播图', icon: 'el-icon-picture', roles: [ROLES.SUPER_ADMIN, ROLES.SUB_ADMIN] }
      },
      {
        path: 'news',
        name: 'AdminNews',
        component: () => import('@/views/admin/news/index.vue'),
        meta: { title: '新闻公告', icon: 'el-icon-news', roles: [ROLES.SUPER_ADMIN, ROLES.SUB_ADMIN] }
      },
      {
        path: 'app-manage',
        name: 'AdminAppManage',
        component: () => import('@/views/admin/app-manage/index.vue'),
        meta: { title: 'APP管理', icon: 'el-icon-mobile-phone', roles: [ROLES.SUPER_ADMIN, ROLES.SUB_ADMIN] }
      },
      {
        path: 'notification',
        name: 'AdminNotification',
        component: () => import('@/views/admin/notification/index.vue'),
        meta: { title: '消息通知', icon: 'el-icon-bell', roles: [ROLES.SUPER_ADMIN, ROLES.SUB_ADMIN] }
      },
      {
        path: 'arrears',
        name: 'AdminArrears',
        component: () => import('@/views/admin/arrears/index.vue'),
        meta: { title: '欠费风控', icon: 'el-icon-warning', roles: [ROLES.SUPER_ADMIN, ROLES.SUB_ADMIN, ROLES.SERVICE_CENTER] }
      },
      {
        path: 'complaints',
        name: 'AdminComplaints',
        component: () => import('@/views/admin/complaints/index.vue'),
        meta: { title: '投诉管理', icon: 'el-icon-warning', roles: [ROLES.SUPER_ADMIN, ROLES.SUB_ADMIN] }
      },
      {
        path: 'appointments',
        name: 'AdminAppointments',
        component: () => import('@/views/admin/appointments/index.vue'),
        meta: { title: '预约管理', icon: 'el-icon-date', roles: [ROLES.SUPER_ADMIN, ROLES.SUB_ADMIN] }
      },
      {
        path: 'home-video',
        name: 'AdminHomeVideo',
        component: () => import('@/views/admin/home-video/index.vue'),
        meta: { title: '首页视频', icon: 'el-icon-video-camera', roles: [ROLES.SUPER_ADMIN, ROLES.SUB_ADMIN] }
      },
      {
        path: 'logistics',
        name: 'AdminLogistics',
        component: () => import('@/views/admin/logistics/index.vue'),
        meta: { title: '物流查询', icon: 'el-icon-truck', roles: [ROLES.SUPER_ADMIN, ROLES.SUB_ADMIN] }
      },
      {
        path: 'accounts',
        name: 'AdminAccounts',
        component: () => import('@/views/admin/accounts/index.vue'),
        meta: { title: '账号管理', icon: 'el-icon-s-check', roles: [ROLES.SUPER_ADMIN] }
      },
      {
        path: 'sub-admin',
        name: 'SubAdmin',
        component: () => import('@/views/admin/sub-admin/index.vue'),
        meta: { title: '子管理员', icon: 'el-icon-s-management', roles: [ROLES.SUPER_ADMIN] }
      },
      {
        path: 'change-password',
        name: 'ChangePassword',
        component: () => import('@/views/admin/change-password/index.vue'),
        meta: { title: '修改密码', icon: 'el-icon-lock', roles: [ROLES.SUPER_ADMIN, ROLES.SUB_ADMIN, ROLES.SERVICE_CENTER] }
      },
      {
        path: 'operation-log',
        name: 'AdminOperationLog',
        component: () => import('@/views/admin/operation-log/index.vue'),
        meta: { title: '操作日志', icon: 'el-icon-s-operation', roles: [ROLES.SUPER_ADMIN] }
      },
      {
        path: 'config',
        name: 'SystemConfig',
        component: () => import('@/views/admin/config/index.vue'),
        meta: { title: '系统配置', icon: 'el-icon-s-tools', roles: [ROLES.SUPER_ADMIN] }
      }
    ]
  },
  // 默认重定向
  {
    path: '/',
    redirect: '/admin/login'
  },
  {
    path: '*',
    redirect: '/admin/login'
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  const isAdminRoute = to.path.startsWith('/admin')
  if (to.meta && to.meta.public) {
    next()
    return
  }

  if (isAdminRoute) {
    const adminToken = store.getters.adminToken

    if (!adminToken) {
      next('/admin/login')
      return
    }

    try {
      await fetchMyPermissions()
    } catch (error) {
      console.error('获取权限失败:', error)
    }

    next()
  } else {
    next()
  }
})

export default router
